module.exports = __webpack_public_path__ + "img/chargingport_1000.c85f6455.jpg";